import Vue from 'vue';
import store from './../../store';
import chartOfAccountsTransformer from './../../transformers/chartOfAccounts';

const success = ({ data }, resolve) => {
  const chartOfAccounts = chartOfAccountsTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllChartOfAccounts', chartOfAccounts);
  resolve(chartOfAccounts);
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/chart_of_accounts')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/chartOfAccounts/all.js